<template>
  <div class="home">
    <Onboarding-Component />
  </div>
</template>

<script>
// @ is an alias to /src
import OnboardingElement from '@/components/onboarding/onboarding.vue'

export default {
  name: 'OnboardingView',
  components: {
    'Onboarding-Component': OnboardingElement
  },
  data: function() {
    return {}
  },
  methods: {
    addListenerForMsgFromPlugin() {
      //const that = this
      //console.log('addListenerForMsgFromPlugin ', that)
    }
  },
  beforeMount: function() {
    //this.addListenerForMsgFromPlugin()
  }
}
</script>
